<template>
  <div>

    <div>
    <el-descriptions title="变更信息" column="1" style="margin-left: 5%;margin-top: 2%;">
        <el-descriptions-item label="资产名称">{{ChangeData.propertyName}}</el-descriptions-item>
        <el-descriptions-item label="变更ID">{{ChangeData.propertyRecordId}}</el-descriptions-item>
        <el-descriptions-item label="变更前使用人姓名">{{ChangeData.beforeUsername}}</el-descriptions-item>
        <el-descriptions-item label="变更后使用人姓名">{{ChangeData.afterUsername}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ChangeData.createDate}}</el-descriptions-item>
        <el-descriptions-item label="变更状态">{{ChangeData.recordState}}</el-descriptions-item>
    </el-descriptions>
    </div>

    <div>
       <el-table
          :data="tableData"
           @row-click="handdle"
           class="tableData"
          max-height="500">
          <el-table-column
            fixed
            prop="propertyRecordId"
            label="变更ID"
            width="150">
          </el-table-column>
          <el-table-column
            prop="propertyName"
            label="资产名称"
            width="120">
          </el-table-column>
          <el-table-column
            prop="beforeUsername"
            label="变更前使用人姓名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="afterUsername"
            label="变更后使用人姓名"
            width="150">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button
                @click="ChangeCheck(scope.row.propertyRecordId)"
                type="text"
                size="small">
                通过审批
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Property_MyChangeDeatil',
     data () {
       return {
         dialogChangeVisible:false,
         tableData:[{
           propertyRecordId:'',
           propertyId:'',
           propertyName:'',
           beforeUserId:'',
           beforeUsername:'',
           afterUserId:'',
           afterUsername:'',
           unitId:'',
           recordState:'',
           createDate:'',
         }],
          ChangeData:{
             propertyRecordId:'',
             propertyId:'',
             propertyName:'',
             beforeUserId:'',
             beforeUsername:'',
             afterUserId:'',
             afterUsername:'',
             unitId:'',
             recordState:'',
             createDate:'',

          },
        };
     },
   mounted:function() {
		// 首先是当页面加载的时候自动渲染这些数据		
			 
		// 展现变更信息   变更信息
       this.showChangeData();
	   
	   // 表格里面的数据
       this.showData();
     },
     methods: {
		 
	   	 // 获取变更的数据那一行的数据
       handdle(row,event,column){
         this.ChangeData = row
       },
	   // 获取变更信息
        showChangeData(){
          this.ChangeData = this.$parent.tableRow
        },
		
		// 主要数据展示给tableData
        showData(){
          var authorization = Cookies.get("Authorization");
          this.axios({
              method: 'GET',
              url: '/property/showWaitReadApply',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{

              this.tableData = resp.data.data

            })
        },
		
		//变更人审核使用人变更申请
        ChangeCheck(val){
          var recordId = {
            recordId:val
          }

          var authorization = Cookies.get("Authorization");
          this.axios({
              method: 'POST',
              url: '/property/checkMsg',
              params:recordId,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
                this.showData()
            })
        }

     }
   }
</script>

<style>
  .tableData{
    width: 45%;
    margin-left: 5%;
    margin-top: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_MyChangeDeatil.vue